/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as _ from 'lodash';

import {CURRENCIES} from '../../../components/util/iso-currencies';
import {formatIsoCurrency} from '../../../components/util/iso-currency-format';

export function formatStatCurrency(stat: any, defaultCurrency?: string, locale = 'en'): string {
  if (_.has(stat, 'currency') && _.isFinite(stat.amount)) {
    const currency = CURRENCIES[(stat.currency).toUpperCase()];
    if (!currency) {
      return formatIsoCurrency(stat.amount, stat.currency, undefined, undefined, undefined, defaultCurrency, locale);
    }
    const number = stat.amount.toFixed(currency.fraction);
    if (_.endsWith(number, '0')) {
      return formatIsoCurrency(parseFloat(number), stat.currency, 0, undefined, undefined, defaultCurrency, locale);
    }
    return formatIsoCurrency(stat.amount, stat.currency, undefined, undefined, undefined, defaultCurrency, locale);
  }
  return '-';
}
